import type React from 'react'
import type { Product } from '../../cpn-components/CpnProductCard/types.js'

export interface HeaderNavigationProps extends Omit<React.HTMLAttributes<HTMLElement>, 'className'> {
  data: any
  menuData: any
  onPrimaryNavClick?: (_category: any, _position: number) => void
  onSidebarNavClick?: (_series: any, _index: number) => void
  onSeriesProductClick?: (_product: any, _position: number, _seriesLabel?: string) => void
  searchResult?: any
  onSearch?: (_value?: string) => void
  isSearching?: boolean
  keywords?: {
    search_term: string
    search_date: string
    shopify_domain: string
    counts: number
  }[]
  headerId?: string
  cartCount: number
  event?: {
    search?: () => void
    cart?: () => void
    profile?: () => void
    livestream?: () => void
    join?: () => void
    login?: () => void
  }
  buildProps: {
    products?: Product[]
    categories?: Record<string, any>
  }
  profile?: UserProfile // 用户信息
  theme?: string
  isTop?: boolean // 是否在顶部
}

export interface MobilePrimaryNavigationData {
  actions: any
  menuOpen?: boolean
  onMenuOpenClick: () => void
  onMenuOpenClose: () => void
}

export interface MobileSecondaryNavigationData {
  title?: string
  onMenuOpenClose: () => void
  onMenuBackClick: () => void
}

export enum HeaderNavigationMenu {
  Primary = 'primary',
  Secondary = 'secondary',
  Third = 'third',
}

export enum HeaderNavigationBlockType {
  Sidebar = 'ipc-navigation-sidebar',
  Supports = 'ipc-navigation-supports',
  Multicol = 'ipc-navigation-multicol',
  Links = 'ipc-navigation-links',
  Resource = 'ipc-navigation-resource',
}

export enum HeaderNavigationActionBlockType {
  Search = 'ipc-navigation-action-search',
  Cart = 'ipc-navigation-action-cart',
  Profile = 'ipc-navigation-action-profile',
  Livestream = 'ipc-navigation-action-livestream',
}

export interface MobileNavigationProps {
  data: any
  menuData: any
  className?: string
  onPrimaryNavClick?: (_category: any, _position: number) => void
}

export interface DesktopNavigationProps {
  data: any
  onNavItemClick?: () => void
  className?: string
  theme?: string
  onPrimaryNavClick?: (_category: any, _position: number) => void
  onSidebarNavClick?: (_series: any, _index: number, _subSubindex?: number) => void
}

type Country = {
  id?: number
  name?: string
  code?: string
}

export type UserProfile = {
  user_id: string
  email: string
  nick_name?: string
  full_name?: string
  first_name?: string
  last_name?: string
  dob?: string
  gender?: string
  phone_number?: string
  phone_account?: string
  country?: Country
  is_subscribe?: boolean
  avatar?: string
  can_change_password?: boolean
  invitation_code?: string
  phone_carrier?: string
  dob_programmed?: boolean
  activated?: boolean
  registed_at?: number
  activated_at?: number
  token?: string
}
